module.exports = __webpack_public_path__ + "img/card-info.2a8f7616.svg";